import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { OMOperator               } from 'src/app/beans/operator/operator.bean';
import { OOperatorCounter         } from 'src/app/beans/operator/operator.counter.bean';
import { CustomColumn, CustomTableComponent } from 'src/app/components/table/custom-table/custom-table.component';

@Component
({
  selector: 'operator-counter-page',
  templateUrl: './operator.counter.page.html',
  styleUrls: ['./operator.counter.page.scss']
})

export class OperatorCounterPage  implements OnInit 
{

  @ViewChild('operatorCounterTable') operatorCounterTable: CustomTableComponent

  values: OOperatorCounter[] = []
  operatorId: number

  constructor(
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit(): void 
  {

  }

  operatorCounterColumns: CustomColumn [] = [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      label: "siteName",
      name : "tables.operator_counter.labels.siteName"
    },
    {
      label: "counterName",
      name : "tables.operator_counter.labels.counterName"
    },

  ]

  async operatorChange(ope: OMOperator){
    console.log(ope);
    this.operatorCounterTable.reloadData()
    this.values = await this.retriveValues( ope.id )
    this.operatorCounterTable.dataLoaded()

    console.log(this.values);
    
  }

  async init(operatorId: number)
  {
    this.operatorId = operatorId
    
    this.values = await this.retriveValues( operatorId )
  }

  async retriveValues( operatorId: number )
  {
    const user = this._session.user().get()

    if(!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.operator().getOperatorCounter((user as User).token, operatorId)

    this._loader.stop()

    if ( !response      ) return 
    if ( !response.list ) return 

    const list = response.list.map( ( el: OOperatorCounter ) => {
      return {
        counterName: el.counterName ? el.counterName : "-",
        siteName: el.siteName ? el.siteName : "-",
        id: el.counterId
      }
    } )

    return list;
  }
}
